import { carouselData } from '@/mocks/home';

const coverImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20entertainment%20headline%20visual%20with%20crimson%20red%20geometric%20accents%2C%20breaking%20news%20editorial%20style%2C%20dramatic%20atmospheric%20lighting%2C%20professional%20media%20feature%20image%2C%20mysterious%20dark%20background&width=800&height=480&seq=carousel-cover-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20celebrity%20secrets%20editorial%20visual%20with%20golden%20amber%20highlights%2C%20entertainment%20news%20feature%20image%2C%20cinematic%20atmosphere%2C%20professional%20media%20design%2C%20dark%20background&width=800&height=480&seq=carousel-cover-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20internet%20economy%20collapse%20editorial%20visual%20with%20red%20accents%2C%20entertainment%20business%20news%20feature%20image%2C%20cinematic%20style%2C%20professional%20dark%20background&width=800&height=480&seq=carousel-cover-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Dark%20investigative%20expose%20editorial%20visual%20with%20crimson%20and%20gold%20geometric%20elements%2C%20entertainment%20scandal%20feature%20image%2C%20cinematic%20dramatic%20lighting%2C%20dark%20background&width=800&height=480&seq=carousel-cover-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20power%20struggle%20editorial%20visual%20with%20warm%20golden%20accents%2C%20entertainment%20industry%20feature%20image%2C%20cinematic%20atmosphere%2C%20professional%20dark%20background&width=800&height=480&seq=carousel-cover-5&orientation=landscape',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          深度解析娱乐圈最受关注的话题事件
        </p>

        <div className="flex flex-col gap-5">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex flex-col md:flex-row gap-5 bg-background-100 border border-background-200/60 hover:border-accent-500/30 rounded-lg overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="md:w-[380px] lg:w-[440px] shrink-0 aspect-video md:aspect-auto relative overflow-hidden bg-background-200">
                <img
                  src={coverImages[item.id]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded">{item.tag}</span>
                </div>
              </div>
              <div className="flex flex-col justify-center p-5 md:p-6 md:pl-0 flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}